<template>

    <div class="container-wrap">

        <div class="container main-content">

            <div class="row">

                <div class="col span_12">

                    <div id="error-404">

                        <h1>404</h1>

                        <h2>Page Not Found</h2>

                        <a class="nectar-button large regular-button accent-color has-icon cursor-pointer"
                           data-color-override="false"
                           data-hover-color-override="false"
                           @click.once="$router.push({ name: 'home' })"
                           style="visibility:visible;"
                        ><span>Back Home </span><i class="icon-button-arrow"></i></a>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

export default {

    name: 'Va404'

}
</script>

<style lang="scss" scoped>
.regular-button {
    border: 0;
    padding: 1rem 3rem;
    color: #ffffff !important;
}
</style>
